import React from "react";
import { useAuth } from "../context/AuthContext";
import { LogOut, BarChart3 } from "lucide-react";
import { motion } from "framer-motion";

export default function Navbar() {
  const { logout } = useAuth();

  return (
    <header className="sticky top-0 bg-white shadow-xl p-4 flex justify-between items-center z-30">
      <div className="flex items-center">
        <BarChart3 className="text-blue-500 mr-2" size={28} />
        <h1 className="text-2xl font-bold text-gray-800 tracking-wide">
          Report Viewer
        </h1>
      </div>
      <motion.button
        onClick={logout}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold px-4 py-2 rounded-lg shadow-md hover:shadow-lg transition duration-200 ease-in-out flex items-center"
      >
        <LogOut size={18} className="mr-2" />
        Logout
      </motion.button>
    </header>
  );
}
